import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

import type { RentmanSettingModuleProps } from '@src/pages/settings/types';

export const ConnectionEmailEnabled: React.FC<RentmanSettingModuleProps> = ({ rentmanUserDefaultData, setRentmanUserDefaultData }) => {
  const handleConnectionEmailEnabled = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRentmanUserDefaultData((prevState) => ({
      ...prevState,
      connection_email_enabled: event.target.checked,
    }));
  };

  return (
    <Form.Group as={Row} className="mb-3" controlId="formHorizontalConnectionEmailEnabled">
      <Form.Label column sm={6}>
        Enable recieving emails when Connection fails.
      </Form.Label>
      <Col sm={6}>
        <Form.Check
          type="switch"
          id="connection-switch"
          label="Enable"
          checked={rentmanUserDefaultData?.connection_email_enabled ? rentmanUserDefaultData?.connection_email_enabled : false}
          onChange={handleConnectionEmailEnabled}
        />
      </Col>
    </Form.Group>
  );
};
